// extracted by mini-css-extract-plugin
module.exports = {"editPic":"CustomerProfile_editPic__2dpBh"};